import { render, staticRenderFns } from "./WsFileInputBtn.vue?vue&type=template&id=54a00e2a&"
import script from "./WsFileInputBtn.vue?vue&type=script&lang=js&"
export * from "./WsFileInputBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports